import React, { useState, useEffect } from 'react';
import './MyDoctors.css';
import { useNavigate } from 'react-router-dom';
import backIcon from "../../Assets/Images/Expand_left.png";
import config from '../../Config';

const MyDoctors = () => {
  const navigate = useNavigate();
  const [doctorAppointments, setDoctorAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const patientid = sessionStorage.getItem('patientid');

  useEffect(() => {
    if (!patientid) {
      console.error('Patient ID not found in session storage!');
      navigate('/error'); // Navigate to an error page or show an alert
      return;
    }

    const fetchDoctorAppointments = async () => {
      try {
        const token = sessionStorage.getItem('authToken'); // Ensure the auth token exists
        if (!token) {
          throw new Error('Authentication token is missing.');
        }

        const response = await fetch(`${config.API_BASE_URL}/patient/doctors/${patientid}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`API Error: ${response.statusText}`);
        }

        const responseData = await response.json();
        if (responseData.status !== 1) {
          throw new Error(responseData.message || 'Failed to fetch data');
        }

        // Extract the doctor appointments from `data` field
        setDoctorAppointments(responseData.data);
      } catch (err) {
        console.error('Error fetching doctor appointments:', err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctorAppointments();
  }, [patientid, navigate]);

  const handleRequestAppointment = (doctor) => {
    navigate('/requestappoinment', { state: { doctor } });
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="treminder-container-doctors">
      <div className="sub-header">
        <button className="back-button" onClick={handleBackClick}>
          <img src={backIcon} alt="Back" className="back-icon" />
        </button>
        <h1 className="title-mydoctors">My Doctors</h1>
      </div>

      <section className="appointment-section">
        <div className="appointment-list">
          {doctorAppointments.length > 0 ? (
            doctorAppointments.map((doctor) => (
              <div className="doctor-card" key={doctor.doctor_id}>
                <div className="doctor-card-left">
                  <img
                    src={doctor.doctor_profile_image || 'default_image_url'}
                    alt={doctor.name || 'Unknown Doctor'}
                  />
                </div>
                <div className="doctor-card-right">
                  <h3>{doctor.name || 'Unknown Doctor'}</h3>
                  {/* <p>Specialization: {doctor.specialization || 'N/A'}</p> */}
                  <p>Next Follow-up:</p>
                  <span className="follow-up-date">{doctor.next_appointment_date || 'N/A'}</span>
                  <p>Last Consultation:</p>
                  <span className="last-appointment-date">{doctor.last_consultation_date || 'N/A'}</span>
                  <button className="appointment-button" onClick={() => handleRequestAppointment(doctor)}>
                    Request Appointment
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>No appointments available.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default MyDoctors;
